<template>
    <transition name="slide-fade">
        <div class="genplan-popup" v-if="isOpen">
            <div class="genplan-popup__wrapper">
                <div class="genplan__canvas">
                    <svg :viewBox="[`0 0 ${renderSize.width} ${renderSize.height}`]"
                         preserveAspectRatio="xMidYMid
                         slice"
                         class="genplan__canvas-svg">
                        <image x="0" y="0" width="100%" height="100%"
                               :xlink:href=render.link></image>
                        <rect width="100%" height="100%"
                              fill-opacity="0.6"
                              mask="url(#visual-canvas__hole)"
                              class="genplan__canvas-overlay"></rect>
                        <path id="1"
                              v-for="element in render.elements" :key="element.id"
                              :link=element.link
                              :d=element.path
                              @click="selected.includes(+element.id) ? selected.splice(selected.indexOf(+element.id), 1)
                                : selected.push(+element.id)"
                              :class="['genplan__canvas-path', {'is-active': selected.includes(+element.id)}]">
                        </path>
                        <defs>
                            <mask id="visual-canvas__hole">
                                <rect fill="white" width="100%" height="100%"></rect>
                                <path v-for="element in render.elements"
                                      :key="element.id"
                                      :d=element.path>
                                </path>
                            </mask>
                        </defs>
                    </svg>
                    <div class="genplan__canvas-close" @click="closeOpen">
                        <ButtonClose />
                    </div>

                    <transition name="slide-fade">
                        <button @click="selectBuilding()"
                                type="button"
                                class="button button_theme_color genplan__canvas-button button_theme_content-width">
                            <span>{{submitButton}}</span>
                        </button>
                    </transition>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import ButtonClose from 'components/button-close/ButtonClose.vue';


export default {
    data() {
        return {
            isOpen   : false,
            selected : [],
            selected2: []
        };
    },
    components: {
        ButtonClose
    },
    methods: {
        ...mapActions(['changeSelected']),

        openModal() {
            this.isOpen = true;
        },
        closeOpen() {
            this.isOpen = false;
        },
        selectBuilding() {
            this.$emit('sendBuilding');
            this.closeOpen();
        }
    },
    computed: {
        ...mapGetters({
            renderSize       : 'GET_CANVAS_SIZE',
            selectedBuildings: 'GET_SELECTED_BUILDINGS',
            render           : 'GET_RENDER'
        }),
        submitButton() {
            // скрываем на время
            // const corpuses = this.selected.join(',');

            if (this.selected.length > 1) {
                return `Выбрать корпуса`;
            } else if (!this.selected.length) {
                return 'Применить';
            }

            return `Выбрать корпус`;
        }
    },
    watch: {
        selectedBuildings() {
            this.selected = this.selectedBuildings;
        }
    }
};
</script>
